/**
 * Default domain used when API_URL is not available or cannot be parsed
 */
export var DEFAULT_DOMAIN = "app";
/**
 * Default base domain URL
 */
export var DEFAULT_BASE_DOMAIN = "https://app.maatai.com";
/**
 * Local development domain
 */
export var LOCAL_DOMAIN = "local";
/**
 * Local development base URL
 */
export var LOCAL_BASE_URL = "http://localhost:8080";
/**
 * Domain patterns for parsing API URLs
 */
export var DOMAIN_PATTERNS = {
    SERVICE_PATTERN: /^api-([^.]+)\.service\.maatai\.com$/,
    DIRECT_PATTERN: /^([^.]+)\.maatai\.com$/,
};
